import SwitchInput from './SwitchInput';

export default SwitchInput;
